import { useState } from 'react'
import { HiOutlineDocumentAdd } from 'react-icons/hi'
import { IoMdAdd } from 'react-icons/io'
import Button from '../../components/General/Button'
import useSnackBars from '../../hooks/SnackbarConsumerHook'

const InventoryCodeForm: React.FC<InventoryProps> = ({ onPropSubmitCode }) => {
  const [code, setCode] = useState<string>('')
  const { addAlert } = useSnackBars()

  const onSubmitCode = (): void => {
    if (code === '') {
      addAlert({
        message: 'Debe especificar un código asociado',
        status: 'error',
      })
      return
    }
    onPropSubmitCode(code)
    setCode('')
  }

  return (
    <div className="mt-5">
      <div className="flex justify-around">
        <div className="flex flex-col w-5/6">
          <label className="font-medium text-primary-900 text-xs dark:text-white mb-2">
            Código
          </label>
          <input
            type="text"
            name="code"
            className="dark:bg-gray-600 dark:border-gray-600 h-7 dark:text-white mr-2"
            value={code}
            maxLength={15}
            onChange={(v) => setCode(v.target.value.toUpperCase().trim())}
            onKeyDown={(e) => e.key === 'Enter' && onSubmitCode()}
          />
        </div>

        {/* <Button
          classes="xl:col-span-3 col-span-3 border-none w-24 mt-4"
          onClick={() => onSubmitCode()}
        >
          <HiOutlineDocumentAdd size={30} className="text-green-600" />
        </Button> */}

        <div
          className="mt-5 w-8 h-8 flex justify-center items-center"
          style={{ backgroundColor: '#1A47AA', borderRadius: 5 }}
        >
          <button
            className="border-none p-0"
            onClick={() => {
              onSubmitCode()
            }}
          >
            <IoMdAdd size={30} color="white" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default InventoryCodeForm

interface InventoryProps {
  onPropSubmitCode: (value: string) => void
}
